import React, { useState } from 'react'
import { get } from 'lodash'

import { useField, useForm } from 'react-final-form'

import { TextInput } from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import { ChromePicker } from 'react-color'

const useStyles = makeStyles({
  picker: {},
  popover: {
    position: 'absolute',
    zIndex: 2,
  },
  cover: {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
  },
})

export const ColorPicker = (props: any) => {
  const classes = useStyles()
  const form = useForm()

  const { initialValues } = form.getState()
  const defaultValue = get(initialValues, props.source, '')
  const { input, meta } = useField(props.source, { value: true })

  const { touched, error } = meta
  const { options, value = '', validate, onChange = () => {}, ...rest } = props

  const [open, setOpen] = useState(false)
  const [inputValue, setInputValue] = useState(defaultValue)

  const handleClick = () => setOpen(!open)
  const handleClose = () => {
    setOpen(false)
    input.onChange(inputValue)
  }

  return (
    <>
      <TextInput
        {...rest}
        onFocus={() => handleClick()}
        options={{ value: inputValue }}
        error={!!(touched && error)}
        value={inputValue}
        validate={inputValue !== '' ? null : validate}
      />
      <div>
        {open ? (
          <div className={classes.popover}>
            <div className={classes.cover} onClick={() => handleClose()} />
            <ChromePicker
              {...options}
              color={inputValue}
              onChange={({ hex }) => {
                setInputValue(hex)
                onChange()
                input.onChange(hex)
              }}
            />
          </div>
        ) : null}
      </div>
    </>
  )
}
